import {Component, OnDestroy, OnInit} from '@angular/core';
import {ConfiguratorService} from '../../../services/configurator/configurator.service';
import SewingPatternInterface from '../../../models/sewing-pattern.interface';
import SewingPatternProject from '../../../models/sewing-pattern-project.model';
import {InspirationRepository} from '../../../repositories/inspiration.repository';
import {InspirationService} from '../../../services/inspiration.service';

@Component({
    selector: 'app-profile-page',
    templateUrl: './profile-page.component.html',
    styleUrls: ['./profile-page.component.css'],
})
export class ProfilePageComponent implements OnInit, OnDestroy {

    projects: SewingPatternProject[] = [];
    savedInspirations: any[] = [];

    hasProjects = true;

    unsubscribeSewingPatterns: any;

    constructor(private configuratorService: ConfiguratorService,
                private inspirationRepository: InspirationRepository,
                private inspirationService: InspirationService) {
    }

    ngOnInit() {
        this.unsubscribeSewingPatterns = this.configuratorService.subscribeSewingPatterns((patternProjects) => {
            this.projects = patternProjects;
            this.hasProjects = patternProjects.length > 0;
        });
    }

    ngOnDestroy() {
        if (this.unsubscribeSewingPatterns && typeof this.unsubscribeSewingPatterns === 'function') {
            this.unsubscribeSewingPatterns();
        }
    }

    ionViewDidEnter() {
        this.inspirationService.getSavedInspirations()
            .then(inspirationIds => {
                this.savedInspirations = inspirationIds.map(id => this.inspirationRepository.getByIdOrFirst(id));
            });
    }

}
